import { render, staticRenderFns } from "./ClientReplicaDetail.vue?vue&type=template&id=ce6356ae&scoped=true"
import script from "./ClientReplicaDetail.vue?vue&type=script&lang=js"
export * from "./ClientReplicaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6356ae",
  null
  
)

export default component.exports